import { isNil } from 'lodash'

import { onlyNumbersAndLetters } from './regex'

const format = (value) => {
  if (isNil(value)) return value

  return onlyNumbersAndLetters(value)
    .slice(0, 14)
    .replace(/([0-9A-Z]{2})([0-9A-Z])/, '$1.$2')
    .replace(/([0-9A-Z]{3})([0-9A-Z])/, '$1.$2')
    .replace(/([0-9A-Z]{3})([0-9A-Z])/, '$1/$2')
    .replace(/([0-9A-Z]{4})(\d{1,2})$/, '$1-$2')
}

export default format
